<template>
  <div>
    <vxe-grid
      ref="listingTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
      cell-class-name="align-top"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.invSkuSetStatus === 'Y'
              ? 'success'
              : row.invSkuSetStatus === 'S' || row.invSkuSetStatus === 'D'
              ? 'danger'
              : row.invSkuSetStatus === 'W'
              ? 'warning'
              : ''
          "
        >
          {{
            row.v_invSkuSetStatus ||
              $l('tag_no_invSkuSetStatus') ||
              '未配置状态'
          }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU：</span><span style="color: #303133">{{ row.evgSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:warehouseSkuName="{ row }">
        <span>{{ row.whProductTitle }}</span>
        <br />
        <span>{{ row.whProductTitleEn }}</span>
      </template>
      <template v-slot:displayInWarehouse="{ row }">
        <span>{{ row.ecomWarehouseName || '' }}</span>
        <br />
        <span>{{ $l('table_cell_whAccount') || '仓库账号' }}：</span>
        <span style="color: #101010">{{ row.accountName }}</span>
      </template>
      <template v-slot:warehouseSkuNo="{ row }">
        <span>{{ $l('table_cell_whSkuNo') || '仓库SKU编号' }}：</span>
        <span style="color: #101010">{{ row.whSkuNo }}</span>
        <br />
        <span>{{ $l('table_cell_whSkuBarcode') || '仓库条码号' }}：</span>
        <span style="color: #101010">{{ row.whSkuBarcode }}</span>
        <br />
        <span>{{ $l('table_cell_whSkuEanCode') || '产品条码号' }}：</span>
        <span style="color: #101010">{{ row.whSkuEanCode }}</span>
        <br />
        <span>{{ $l('table_cell_whReferenceNo') || '自定义编号' }}：</span>
        <span style="color: #101010">{{ row.whReferenceNo }}</span>
      </template>
      <template v-slot:displayUnit="{ row }">
        <span>UNIT:</span>
        <span style="color: #303133">
          {{ row.pkgLength }}x{{ row.pkgWidth }}x{{ row.pkgHeight }}cm
        </span>
        <br />
        <span>G.W:</span>
        <span style="color: #303133">{{ row.pkgWeight }} kg</span>
        <br />
        <span>CBM:</span>
        <span style="color: #303133">{{ row.pkgCbm }} m³</span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImageUrl', 'col-opt']
      if (filterColumns.includes(property)) return

      const $listingTable = this.$refs.listingTable
      $listingTable.toggleCheckboxRow(row)
      const data = $listingTable.getCheckboxRecords(true)
      this.$emit('checkboxChange', data)
    },
    handleCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      const { invSkuSetCode } = data
      switch (menuType) {
        case 'detail':
          this.$emit('showDetail', {
            invSkuSetCode,
            disabled: true,
            title: this.$l('dialog_title_detail_sku') || '上架信息',
          })
          break
        case 'edit':
          this.$emit('showDetail', {
            invSkuSetCode,
            disabled: false,
            title: this.$l('dialog_title_update_sku') || '修改SKU',
          })
          break
        case 'del':
          this.del(data)
          break
        case 'availableSale':
          this.$emit('batchListing', [invSkuSetCode])
          break
        case 'stop':
          this.$emit('bulkDeactivation', [invSkuSetCode])
          break
        case 'syncLc':
          this.syncLc(data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    syncLc({ invSkuSetCode }) {
      this.$confirm(
        this.$l('tips_confirm_sync_lc_record') || '是否要推送该记录',
        this.$l('tip_confirm_sync_lc_record_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_del_record_confirm') || '确定',
          cancelButtonText: this.$l('btn_del_record_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomOverseasInvSkuSetSyncLcApi({ invSkuSetCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(this.$l('tips_sync_lc_error') || '推送失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('tips_sync_lc_success') || '推送成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    del({ invSkuSetCode }) {
      this.$confirm(
        this.$l('tips_confirm_del_record') || '是否要删除该记录',
        this.$l('tip_confirm_del_record_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_del_record_confirm') || '确定',
          cancelButtonText: this.$l('btn_del_record_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomOverseasInvSkuSetDelApi({ invSkuSetCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(this.$l('tips_del_error') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('tips_del_success') || '删除成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
